import React from 'react';

var LobbyWr = function (_a) {
    var children = _a.children, videoSrc = _a.videoSrc;
    return (React.createElement("div", { className: 'pgc-lobby-wr' },
        React.createElement("video", { className: 'w-lobby-bg-video', src: videoSrc, autoPlay: true, loop: true, muted: true }),
        children));
};

export { LobbyWr };
